import { Box, Divider, Modal } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { ContainerImagesEditModalFileUpload } from '~/src/components/molecules/ContainerOrder/images/ContainerImagesEditModalFileUpload'
import { ContainerImagesEditModalFileUploadMaximum } from '~/src/components/molecules/ContainerOrder/images/ContainerImagesEditModalFileUploadMaximum'
import { ContainerImagesEditModalHeader } from '~/src/components/molecules/ContainerOrder/images/ContainerImagesEditModalHeader'
import { ContainerImagesEditModalImage } from '~/src/components/molecules/ContainerOrder/images/ContainerImagesEditModalImage'
import { DeleteImages } from '~/src/components/molecules/ContainerOrder/images/DeleteImages'
import { useMessage } from '~/src/hooks/useMessage'
import { useMultipleFileUpload } from '~/src/hooks/useMultipleFileUpload'
import { containerRepository, otherRepository } from '~/src/repositories'
import { IImage } from '~/src/repositories/Container/schema/IImage'
import { ModalBase } from './ContainerImagesEditModal.styles'

interface ContainerImagesEditModalProps {
  containerImages: IImage[]
  isOpen: boolean
  handleClose: () => void
}
type TUpladFile = {
  path: string
  filename: string
}
export const ContainerImagesEditModal: React.FC<ContainerImagesEditModalProps> = ({
  containerImages,
  isOpen,
  handleClose,
}) => {
  const { t } = useTranslation()
  const location = useLocation()
  // @ts-ignore
  const { id } = location.state.item as any

  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [deleteIds, setDeleteIds] = useState<string[]>([])

  const { filesToUpload } = useMultipleFileUpload()
  const { handleOpenWithErrorMessage } = useMessage()

  /**
   * 登録用関数
   */
  const uploadFile = async (files: File[]) => {
    if (files) {
      setIsUploading(true)

      // S3 Upload
      const uploadFileList: TUpladFile[] = []
      if (!!files.length) {
        for (const file of files) {
          // s3のupload先のurlを取得
          const uploadS3BucketPath = await otherRepository.getDownloadFileUrl({
            'Content-Type': file.type,
          })
          // put
          await otherRepository.putFile(file, uploadS3BucketPath.url)
          uploadFileList.push({ filename: file.name, path: uploadS3BucketPath.path })
        }
      }

      // POST /containers/images
      try {
        if (uploadFileList && uploadFileList.length > 0) {
          containerRepository.postContainersImages(id, uploadFileList)
          window.location.reload()
        }
      } catch (e: any) {
        handleOpenWithErrorMessage(e)
      } finally {
        setIsUploading(false)
      }
    }
  }

  const onChangeInputFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    if (files && files.length > 0) {
      uploadFile(Array.from(files))
    }
  }

  /**
   * 削除用関数
   */
  const onClickDelete = () => {
    setIsUploading(true)
    //
    containerRepository
      .deleteContainersImages(id, deleteIds)
      .then(() => {
        window.location.reload()
      })
      .catch((e) => {
        handleOpenWithErrorMessage(e)
      })
      .finally(() => {
        setIsUploading(false)
      })
  }
  const onClickCancel = () => {
    setDeleteIds([])
  }

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ModalBase>
        {isUploading ? (
          <Box sx={{ textAlign: 'center' }}>Updating...</Box>
        ) : (
          <>
            <ContainerImagesEditModalHeader
              labelText={t('container_order_detail.label_edit')}
              handleClose={handleClose}
            />

            <ContainerImagesEditModalImage
              containerImages={containerImages}
              deleteIds={deleteIds}
              setDeleteIds={setDeleteIds}
            />

            {deleteIds.length > 0 && (
              <DeleteImages onClickDelete={onClickDelete} onClickCancel={onClickCancel} />
            )}

            {containerImages.length < 100 ? (
              <ContainerImagesEditModalFileUpload
                labelText={t('container_order_detail.drop_your_files_here_or')}
                buttonText={t('container_order_detail.select_files')}
                uploadFile={uploadFile}
                onChangeInputFile={onChangeInputFile}
                filesToUpload={filesToUpload}
              />
            ) : (
              <ContainerImagesEditModalFileUploadMaximum
                labelText={t('container_order_detail.upload_maximum')}
              />
            )}
          </>
        )}
      </ModalBase>
    </Modal>
  )
}
